import React from 'react';
import { motion } from 'framer-motion';
export function ProductShowcase() {
  return <section className="relative w-full overflow-hidden" data-id="element-185">
      {/* Full-width collage image */}
      <div className="relative w-full min-h-[400px] md:min-h-[550px]" data-id="element-186">
        <img src="https://cdn.magicpatterns.com/uploads/qbLVzh8SGpQRF82vnXZM7d/image.png" alt="Collage de productos de fiesta - cajitas, bolsitas, invitaciones, toppers y más" className="w-full h-full object-cover absolute inset-0" data-id="element-187" />

        {/* Center text overlay */}
        <div className="absolute inset-0 flex items-center justify-center px-4" data-id="element-188">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          ease: 'easeOut'
        }} className="bg-white/95 backdrop-blur-sm rounded-3xl px-8 py-10 md:px-14 md:py-12 max-w-2xl text-center shadow-xl" data-id="element-189">
            <h2 className="text-2xl md:text-4xl font-black text-purple-700 mb-4" data-id="element-190">
              🎊 Tu candy bar perfecto empieza aquí
            </h2>
            <p className="text-gray-600 font-medium text-base md:text-lg leading-relaxed" data-id="element-191">
              Plantillas listas para personalizar e imprimir: cajitas, bolsitas,
              invitaciones, envoltorios, cuadros, toppers, etiquetas… ¡y mucho
              más para que tu fiesta sea inolvidable!
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}